export default __webpack_public_path__ + "static/media/goopter-hardware-solution-robots.e167844b.jpg";